const ReportSection = ({ children, sectionIndex, title }: { title: string; sectionIndex: number; children: any }) => {
  return (
    <div className="flex flex-col w-full h-full bg-bzblue-100 my-2 max-w-4xl border border-bzblue-400 rounded-md overflow-hidden">
      <div className="flex flex-row justify-between items-center w-full min-h-12 px-4 py-3 border-b border-b-bzblue-400">
        <div className="flex items-center gap-3 min-w-0">
          <div className="shrink-0 bg-bzblue-700 rounded-md w-6 h-6 flex justify-center items-center text-white text-sm">
            {sectionIndex}
          </div>
          <div className="text-md text-bzblue-900 break-words min-w-0">{title}</div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default ReportSection;
